export function getAxiosErrorMessage(error, fallback = "حدث خطأ غير متوقع.") {
  if (!error?.response) {
    if (error?.code === "ECONNABORTED") {
      return "انتهت مهلة الاتصال بالخادم. يرجى المحاولة لاحقًا.";
    }
    return "تعذر الاتصال بالخادم. تحقق من اتصال الإنترنت وحاول مرة أخرى.";
  }

  const { status, data } = error.response;
  const serverMessage = data?.message || data?.error;

  if (status === 401 || status === 403) {
    return serverMessage || "خطأ في الرقم الوظيفي أو كلمة المرور.";
  }

  if (status === 422) {
    return serverMessage || "البيانات المدخلة غير صحيحة.";
  }

  if (status >= 500) {
    if (serverMessage && serverMessage !== "Server Error") {
      return serverMessage;
    }
    return "حدث خطأ في الخادم. يرجى المحاولة لاحقًا أو التواصل مع الدعم الفني.";
  }

  return serverMessage || fallback;
}
